var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "hamburger-btn",
      class: _vm.rootClasses,
      attrs: {
        "aria-label": _vm.title,
        "aria-controls": "navigation",
        "aria-expanded": _vm.menuSidebar ? "true" : "false"
      },
      on: {
        click: function($event) {
          return _vm.onClick(!_vm.menuSidebar)
        }
      }
    },
    [
      _c("span", { staticClass: "hamburger-btn--title" }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "hamburger-btn--hamburger hamburger",
          class: _vm.hamburgerClasses
        },
        [_vm._m(0)]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0e07b3c", { render: render, staticRenderFns: staticRenderFns })
  }
}